// extracted by mini-css-extract-plugin
export default {"tableWrap":"SpecificationTable_tableWrap__yzp4F"};